import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { isSP } from "../../common/functions/isSP.es6";

gsap.registerPlugin(ScrollTrigger);

export default class FamiliesSingle {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelector(".js-families_single")) {
            this.switchImage();
            this.setParallax();
            this.setCardMove();
            this.setInitialVariation();
        }
    }

    setCardMove() {
        const card = document.querySelector(".families_single__header");
        const ph = document.querySelector(".families_single__phmain_wrap");
        const catchImg = document.querySelector(".families_single__catch");
        const light = document.querySelector(".families_single__header__pattern__light");

        window.addEventListener("mousemove", (e) => {
            if (!isSP()) {
                const xPos = e.clientX - window.innerWidth / 2;
                const yPos = e.clientY - window.innerHeight / 2;

                gsap.to(card, { rotateY: -xPos * 0.0025, rotateX: -yPos * 0.005, duration: 0.6 });
                gsap.to(ph, { x: xPos * 0.005, y: yPos * 0.005, duration: 1 });
                gsap.to(catchImg, { x: xPos * 0.01, y: yPos * 0.01, duration: 1 });
                gsap.to(light, { x: xPos * 1, y: yPos * 1, duration: 1 });
            }
        });
    }

    setParallax() {
        //Ring Parallax
        const frames = [...document.querySelectorAll(".js-single_frame")];

        if (!isSP()) {
            frames.forEach((item) => {
                gsap.fromTo(
                    item,
                    { yPercent: 20 },
                    {
                        yPercent: -20,
                        scrollTrigger: {
                            trigger: item,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true,
                        },
                    }
                );
            });
        }
    }

    setInitialVariation() {
        const firstPh = document.querySelector('.families_single__phmain[data-index="0"]');
        const variationBtn = document.querySelector(".js-variationchange");
        const variationWrap = firstPh.querySelector(".js-variation_wrap");

        if (variationWrap) {
            variationBtn.setAttribute("data-active", "1");
        }
    }

    switchImage() {
        const mainph = [...document.querySelectorAll(".js-mainph")];
        const thumbttl = [...document.querySelectorAll(".js-thumbttl")];
        const btn = [...document.querySelectorAll(".js-thumbitem")];
        const variationBtn = document.querySelector(".js-variationchange");

        btn.forEach((item) => {
            item.addEventListener("click", () => {
                btn.forEach((item) => item.setAttribute("data-active", "0"));
                item.setAttribute("data-active", "1");

                const itemIndex = parseInt(item.getAttribute("data-index"));

                mainph.forEach((ph) => {
                    if (parseInt(ph.getAttribute("data-index")) === itemIndex) {
                        ph.setAttribute("data-active", "1");

                        //variationのON/OFF
                        const variationWrap = ph.querySelector(".js-variation_wrap");

                        if (variationWrap) {
                            variationBtn.setAttribute("data-active", "1");
                        } else {
                            variationBtn.removeAttribute("data-active");
                        }
                    } else {
                        ph.setAttribute("data-active", "0");
                    }
                });

                thumbttl.forEach((ttl) => {
                    if (parseInt(ttl.getAttribute("data-index")) === itemIndex) {
                        ttl.setAttribute("data-active", "1");
                    } else {
                        ttl.setAttribute("data-active", "0");
                    }
                });

                //おぎや処理
                if (document.querySelector('.js-families_single[data-id="ogiyamilk"]')) {
                    const catchArray = [...document.querySelectorAll(".families_single__catch")];
                    if (parseInt(item.getAttribute("data-index")) === 2) {
                        catchArray.forEach((item) => {
                            item.setAttribute("data-alternate", "1");
                            const imgs = [...item.querySelectorAll("img")];
                            imgs[0].removeAttribute("data-active");
                            imgs[1].setAttribute("data-active", "1");
                        });
                    } else {
                        catchArray.forEach((item) => {
                            item.removeAttribute("data-alternate");
                            const imgs = [...item.querySelectorAll("img")];
                            imgs[0].setAttribute("data-active", "1");
                            imgs[1].removeAttribute("data-active");
                        });
                    }
                }
            });
        });

        variationBtn.addEventListener("click", () => {
            const nowMainPh = document.querySelector('.js-mainph[data-active="1"]');
            const nowThumbTtl = document.querySelector('.js-thumbttl[data-active="1"]');
            const variationWrap = nowMainPh.querySelector(".js-variation_wrap");

            if (variationWrap) {
                //画像変更
                const items = [...variationWrap.querySelectorAll("img")];
                const nowIndex = parseInt(variationWrap.getAttribute("data-activeindex"));
                let nextIndex = nowIndex + 1;

                if (nextIndex > items.length) {
                    nextIndex = 1;
                }
                variationWrap.setAttribute("data-activeindex", nextIndex);
                nowMainPh.setAttribute("data-variationindex", nextIndex);

                //タイトル変更
                nowThumbTtl.textContent = items[nextIndex - 1].getAttribute("data-ttl");
            }
        });
    }
}
